angular.module('PinMeTo.services').factory('countryData', [
	'$http',
	'$q',
	function ($http, $q) {
		'use strict';

		let _allCountries = [],
			_getCountries = function (callback) {
				if (_allCountries.length > 0) {
					callback(_allCountries);
				}
				$http.get('api/countries', { cache: true }).then(function (res) {
					if (res.status === 200) {
						_allCountries = res.data;
						callback(_allCountries);
					}
				});
			},
			_allCountryNames = function (callback) {
				_getCountries(function (countries) {
					callback(
						countries.map(function (x) {
							return x.name;
						})
					);
				});
			};

		const getCountryCodes = (function () {
			let cache = [];

			const hasCallingCode = function (country) {
				return country.countryCallingCodes.length > 0;
			};

			const toNameAndCallingCode = function (country) {
				return country.countryCallingCodes.map(function (cc) {
					return {
						name: country.name,
						callingCode: cc,
						short: country.alpha2,
						alpha2: country.alpha2
					};
				});
			};

			const concatArrays = function (a, b) {
				return a.concat(b);
			};

			return function () {
				if (cache.length === 0) {
					return $http.get('api/countries/').then(function (res) {
						cache = res.data.filter(hasCallingCode).map(toNameAndCallingCode).reduce(concatArrays);
						return cache;
					});
				} else {
					return $q.resolve(cache);
				}
			};
		})();

		const getCountryData = (function () {
			let cache = {
				countriesRequiresRegion: new Set(),
				countryRegions: new Map(),
				provinces: new Map(),
				countriesNotRequireZip: []
			};
			return function () {
				if (cache.countryRegions.size === 0) {
					return $http.get('api/countrydata/').then(function (res) {
						let cn = res.data.countries.filter(x => x.ISO === 'CN');
						let list;
						if (cn && cn[0]) {
							list = cn[0].regions;
						} else {
							list = null;
						}
						cache = {
							countriesRequiresRegion: new Set(res.data.countriesRequiresRegion),
							countryRegions: new Map(
								res.data.countries.map(function (x) {
									return [x.ISO, x.regions];
								})
							),
							provinces: list,
							countriesNotRequireZip: res.data.countriesNotRequireZip
						};
						return cache;
					});
				} else {
					return $q.resolve(cache);
				}
			};
		})();

		return {
			getCountryCodes: getCountryCodes,
			getCountryData: getCountryData,
			allCountryNames: _allCountryNames,
			allCountries: _getCountries
		};
	}
]);
